import React, { useState } from "react";
import { Control, actions } from "react-redux-form";
import { Row, Col, Input, Button } from "reactstrap";
import { compose, withState, withHandlers } from "recompose";
import shortid from "shortid";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";
import {Trans} from "react-i18next";

import {
  FormGroup,
  DatePicker,
  required,
  Page,
  onMount,
  withReload,
  withLocalForm,
} from "components/common";
import {
  withXeroErrors,
  LineItems,
  SalesEditActions,
  withContactSearch,
  Attachments,
  withOptions,
  Payment,
  withDocumentRenderer,
} from "components";
import { BillDocument } from "components/documents";
import deepPick from "deepPick";
import moment from "moment";
import { formatDate } from "../../../../services/util";
import BackButton from "components/refactoring/BackButton";
import {filterAndValidateLineItems, getBlankLineItems} from "../../../../components/LineItems";

export const EditBill = ({
  item,
  LocalForm,
  onSubmit,
  xero,
  handleSave,
  dispatch,
  handlePaymentAdded,
  handleAttachmentsChanged,
  ContactSearch,
  XeroErrors,
  BillOptions,
  organisation,
  DocumentRenderer,
  DownloadDocument,
  history,
  loading,
  t,
}) => {


const viewLink = () => {
  const { InvoiceID } = item;

  history.push(`/purchases/bills/view/${InvoiceID}`)
};

const [addBillNumber, setBillNumber] = useState()

  return (


  <div>
    <Page
        title={
          item.InvoiceID
            ? t(`Edit Bill {{ Reference }}`, {
                Reference: item.InvoiceNumber,
              })
            : t("Create New Bill")
        }
      translate={false}
    > 
      <BackButton/>
      <XeroErrors />
      <div className="d-flex justify-content-end pb-3">
        {item.InvoiceID && <DownloadDocument className="mr-2" />}
        {item.Attachments ? (
          <Attachments
            xero={xero}
            hideIncludeOnline
            onAttachmentsChanged={handleAttachmentsChanged}
            baseUrl={`invoices/${item.InvoiceID}`}  
            attachments={item.Attachments}
          />
        ) : null}
        <div className="mx-1" />
        {!!item.InvoiceID && <BillOptions />}
        {!!item.InvoiceID &&
          <button
              type="button"
              className="btn-sm btn btn-primary"
              onClick={viewLink}>
              <Trans>View Bill</Trans>
            </button>
        }
      </div>
      
      <LocalForm
        onSubmit={onSubmit}
        validators={{
          Contact: { required },
          Date: { required },
        }}
      >
        <Row>
          <Col xs={false} md={3}>
            <FormGroup label="From" model=".Contact" addControlClass={false} className="pt-2 pb-2">
              <ContactSearch model=".Contact" style={{backgroundColor:'#F4F7FE'}}/>
            </FormGroup>
          </Col>
          <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label="Date" model=".Date">
              <DatePicker type="date" model=".Date" className="form-control" />
            </FormGroup>
          </Col>
          <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label="Due Date" model=".DueDate">
              <DatePicker type="date" model=".DueDate" className="form-control" />
            </FormGroup>
          </Col>
          <Col xs={false} md={3}>
            <FormGroup label="Status" className="pt-2 pb-2">
              <Control.text model=".Status" readOnly />
            </FormGroup>
          </Col>
          <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label="Planned Payment Date" model=".PlannedPaymentDate">
              <DatePicker type="date"
                model=".PlannedPaymentDate"
                className="form-control"
              />
            </FormGroup>
          </Col>
          {/* <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label="Bill Number" model=".InvoiceNumber">
              <Control.text updateOn="blur" model=".InvoiceNumber" />
            </FormGroup>
          </Col> */}
          <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label={(item.InvoiceNumber || addBillNumber) ? "Reference" : "Automated Reference Number"} model=".InvoiceNumber">
              <div className="d-flex">
                <Control.text updateOn="blur" disabled={!addBillNumber} model=".InvoiceNumber" placeholder={addBillNumber ? "" : "PAY-AUTO"}/>
                <Button outline size="sm" color={addBillNumber ? "danger" : "success"} onClick={() => setBillNumber(!addBillNumber)}><i className={`fa fa-${addBillNumber ? "lock" : "unlock"}`}/></Button>
              </div>
            </FormGroup>
          </Col>
          <Col xs={false} md={3} className="pt-2 pb-2">
            <FormGroup label="Note" model=".Reference">
              <Control.text updateOn="blur" model=".Reference" />
            </FormGroup>
          </Col>
        </Row>
        <hr />
        <LineItems
          isNewInvoice={item.InvoiceID ? false : true}
          organisation={organisation}
          item={item}
          dispatch={dispatch}
          xero={xero}
        />
        {loading ?
          <Button color="primary" disabled><span className="fa fa-spinner fa-spin"/> <Trans>Saving</Trans></Button>
          :
          <SalesEditActions onSave={handleSave} item={item} />
        }
      </LocalForm>
      <DocumentRenderer component={BillDocument} />
    </Page>
    {item.Status === "AUTHORISED" && (
      <>
        <hr />
        <Payment
          invoice={item}
          organisation={organisation}
          onPaymentAdded={handlePaymentAdded}
          xero={xero}
        />
      </>
    )}
  </div>
)};

const enhance = compose(
  withReload(),
  onMount(({ match, xero, location }) => () => {
    const { id } = match.params;
    let item = null;

    if (id === "new") {
      item = get(location, "state.copy") || {
        LineItems: getBlankLineItems(),
        Status: "DRAFT",
        Date: formatDate(moment()),
        Type: "ACCPAY",
      };
    } else {
      item = xero
        .get(`invoices/${match.params.id}`)
        .get("data")
        .then((item) => ({
          ...item,
          LineItems: item.LineItems.map((i) => ({
            ...i,
            _id: shortid(),
          })),
        }));
    }

    return Promise.props({
      item,
      organisation: xero.get("organisations").get("data").get(0),
    });
  }),
  withLocalForm({
    initialState: ({ item }) => item,
    stateKey: "item",
    formKey: "form",
  }),
  withState('loading', 'setLoading', false),
  withContactSearch(),
  withDocumentRenderer({
    onDownload:
      ({ item, xero }) =>
      (getDocument) => {
        getDocument(
          { item },
          `bill_${item.InvoiceNumber || item.Reference}.pdf`
        );
      },
  }),
  withXeroErrors(),
  withHandlers({
    handleAttachmentsChanged:
      ({ xero, match, dispatch }) =>
      () => {
        xero
          .get(`invoices/${match.params.id}/attachments`)
          .get("data")
          .tap((d) => dispatch(actions.change("local.Attachments", d)));
      },
    handleSave:
      ({item, xero, history, match, setXeroErrors, reload, t, form, setLoading, dispatch}) =>
      async ({ draft, approve, submit, addAnother } = {}) => {
        const incompleteForm = "Incomplete Form"
        const contactValid = form.Contact?.$form?.valid !== undefined
        ? form.Contact.$form.valid
        : form.Contact?.valid;
        const dateValid = form?.Date?.valid || false
        const dueDateValid = item?.DueDate
        
        if (!contactValid) {
          NotificationManager.error(t("Please Enter A Contact Name"), incompleteForm);
          return
        } else if (!dateValid) {
          NotificationManager.error(t("The Date is empty, please add a date."), incompleteForm);
          return
        } else if (dueDateValid === null || dueDateValid === undefined) {
          NotificationManager.error(t("Due Date is empty, please add a duedate."), incompleteForm);
          return
        }

        const { result: LineItems, error } = filterAndValidateLineItems(
          dispatch
        )(item.LineItems);

        if (error) {
          return;
        }

        let Status = item.Status;
        if (draft) Status = "DRAFT";
        if (approve) Status = "AUTHORISED";
        if (submit) Status = "SUBMITTED";
        setXeroErrors(null);
        const { InvoiceID } = item;

        const allowedProps = [
          "Type",
          "Contact.ContactID",
          "Date",
          "DueDate",
          "Status",
          "LineAmountTypes",
          "LineItems",
          "SubTotal",
          "TotalTax",
          "Total",
          "TotalDiscount",
          "CurrencyCode",
          "CurrencyRate",
          "InvoiceID",
          "InvoiceNumber",
          "Reference",
          "ExpectedPaymentDate",
          "PlannedPaymentDate",
        ];

        setLoading(true);

        {/* Filter Start Line Items */}

        if (!item.InvoiceNumber) {
          // NotificationManager.info("No Bill Number, Generate Auto.")
          const data = await xero.get(`invoices`, {
            params: {
              extra_params: {
                where: `Type="ACCPAY"`,
                // summaryOnly: true,
                order: "Date Desc"
              }}}).get("data")

          let maxNumber = 0;
          const prefix = "PAY"

            for (const d of data) {
            
              if (d?.InvoiceNumber?.startsWith(prefix)) {
                const parts = d.InvoiceNumber.split("-");
                const num = parseInt(parts[1]);
                if (num > maxNumber) {
                  maxNumber = num;
                }
              }
            }
          
          const newReference = `${prefix}-${(maxNumber + 1).toString().padStart(4, '0')}`;
          item = {...item, InvoiceNumber:newReference}
        }

        const lines = item.LineItems.map((el, index) => {
          const lineItem = item?.LineItems[index];
        
          if (lineItem?.ItemCode || lineItem?.Description) {
            if (!lineItem?.UnitAmount && !lineItem?.ItemCode) {
              return { ...el, UnitAmount: 1, };
            } else {
              return el;
            }
          }
          return el;
        });

        const linesRefactor = lines.filter((el, index) => {
          if (lines[index]?.ItemCode ||lines[index]?.Description) {
            return el;
          }
        });

        item = {...item, LineItems:linesRefactor}

        {/* Filter End Line Items */}

        const allowedItem = deepPick(item, allowedProps);

        const p = InvoiceID
          ? xero.put(`invoices/${InvoiceID}`, {
              ...allowedItem,
              Status,
              LineItems,
            })
          : xero.post("invoices", {
              ...allowedItem,
              Status,
              LineItems,
            });

        p.then(({ data: { InvoiceID } }) => {
          NotificationManager.success(t("Bill saved successfully"));
          setLoading(false);

          if (addAnother) {
            history.push(match.path.replace(":id", "new"));
          } else {
            history.replace(`/purchases/bills/view/${InvoiceID}`);
          }
          reload();
        }).catch((error) => {
          setXeroErrors(error);
          setLoading(false);
        }, setXeroErrors);
      },
    handlePaymentAdded:
      ({ reload }) =>
      () => {
        reload();
      },
  }),
  withOptions()
);

export default enhance(EditBill);